class NavbarController {

  constructor(AuthorisationService, $state) {
    this.menuOpen = false;
    this.AuthorisationService = AuthorisationService;
    this.$state = $state;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }

  logout() {
    var self = this;

    self.AuthorisationService.logout();
    self.$state.go('login');
  }
}
NavbarController.$inject = ['AuthorisationService', '$state'];
export default NavbarController;
